<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="sales"
    v-if="renderComponent"
    :maskFields="maskFields"
    :indexNested="true"
    :disablePagination="true"
    :showExpand="true"
    :containTopToolbar="containTopToolbar"
    :hasTableTitle="hasTableTitle"
    :tableTitle="tableTitle"
    :customExpandIcon="true"
    @row-clicked="handleRowClicked"
    class="row-pointer"
    :containSearchBar="false"
    :showCheckBoxSelectIndex="true"    
    @checkBoxSelectionListChanged="$emit('checkBoxSelectionListChanged', $event)"
  >
  <!-- @checkBoxSelectionListChanged="checkBoxSelectionListUpdated" -->

    <template v-slot:expand="{ item, headers }">
      <td :colspan="headers.length" :class="'px-0 px-sm-2 px-md-6 mt-3 ' + ($vuetify.breakpoint.smAndDown ? 'v-data-table__mobile-row': '')">
        <ExitItemIndex
          v-if="true"
          :loading="false"
          :dummyExitMovementItems.sync="item.dummyExitMovementItemsAttributes"          
          class="mt-6"
          :modelType="modelType"          
          :readOnly="readOnly"
        />
      </td>
      <!-- <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :typeText="typeText"
        :modelType="modelType"
      /> -->
    </template>

    <template v-slot:expandColumn="{ item, isExpanded, expand }">
      <v-btn text color="primary" v-if="!isExpanded">Ver Produtos</v-btn>
      <v-btn text color="primary" v-if="isExpanded"><v-icon left>mdi-eye-off</v-icon> Produtos</v-btn>
    </template>   

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import ExitItemIndex from "@models/sales/nfpe_multi_sales/exit_item_index.vue";

export default {
  name: "SaleIndex",
  data() {
    return {
      selectedItems: [],
      loading: false,
      pageLoading: false,
      renderComponent: true,
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code"},
        { text: "Data da venda", align: "left", sortable: true, value: "date" },
        { text: "R$", align: "left", sortable: true, value: "totalPrice"},
        // { text: "Forma de Pagamento", align: "left", sortable: true, value: "paymentMethod.name" },
        // { text: "Conta", align: "left", sortable: true, value: "bankAccount.name" },
        // { text: "Condição", align: "left", sortable: true, value: "paymentCondition.description" },
        // { text: "Intervalo", align: "left", sortable: true, value: "installmentsInterval.description"},
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        // { text: "Ações", value: "action", sortable: false },
        { text: "Produtos", value: "data-table-expand", sortable: false }
      ],
      maskFields: [
        { field: 'totalPrice',mask: 'currency'},
        { field: 'date', mask: 'date'},
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,    
    ExitItemIndex: ExitItemIndex,
  },
  props: {
    modelType: {
      type: String,
    },
    sales: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    },    
    containTopToolbar: {
      type: Boolean,
      default: true
    },
    hasTableTitle: {
      type: Boolean,
      default: false
    },
    tableTitle: {
      type: String
    },
    modelNameSingular: {
      type: String,
      default: "Produto"
    },
    modelNamePlural: {
      type: String,
      default: "Produtos"
    },
  },
  mounted() {
  },
  computed: {
    
  },
  methods: {    
    // checkBoxSelectionListUpdated: function(value){
    //   // console.log("value: ", value);
    //   this.selectedItems = value.map(sale => sale.id);
    // },
    handleRowClicked: function(rowArguments) {
      // console.log("row click", rowArguments);      
      if (rowArguments && rowArguments[1]) {
        rowArguments[1].expand(!rowArguments[1].isExpanded);
      }
    }
  }
};
</script>

<style lang="css" scoped>
  .row-pointer >>> tbody tr :hover {
    cursor: pointer;
  }
</style>
